import { createStore } from "vuex";
import authModule from "./authModule";
import numbersModule from "./numbersModule";
import activationModule from "./activationModule";
import notificationsModule from "./notifications";
import userModule from "./userModule";
import navBarModule from "./navBarModule";
import telephonyModule from './telephonyModule'
import tiktokModule from "./tiktokModule";
import invoiceModule from './invoiceModule'

const store = createStore({
    state() {
        return {
            componentDialog: "",
            isFooterQuestions: true,
            isDialogOpen: false,
            isRelogin: false,
            dialogParams: {}, // {name, params, info, next, method}
            isNavOpen: true,
            bodyClass: [],
            isAuth: false,
            isAscending: true,
            paymentSystem: "",
            language: "",
            sliderValue: { months: 1, viber: 0, telegram: 0 },
            fixedUserBar: false,
            numberData: {}, // {number, system, number_type, serverId} - объект с данными о номере (при активации)
            message: null,
            number: {},
            tariffsTab: "payment",
            toastContent: { status: '', description: '' },
        };
    },
    getters: {
        getNumber(state) {
            return state.numberData.number;
        },
        getNextDialog(state) {
            return state.dialogParams?.next
        },
        getIsRelogin(state) {
            return state.isRelogin
        },

        bodyClassList(state) {
            document.body.classList = state.bodyClass.join(" ");
            // console.log("bodyClassList - ", state.bodyClass)
            return state.bodyClass.length;
        },
    },
    mutations: {
        updateDialogParamsInfo(state, params) {
          state.dialogParams.info = {
              ...state.dialogParams?.info,
              ...params
          }
        },
        setTypeOfDialogAction(state, name = '') {
            state.dialogParams.action = name
        },
        setNextDialog(state, name = '') {
            state.dialogParams.next = name
        },
        setDialog(state, name) {
            state.componentDialog = name;
        },
        setIsOpenDialog(state, newStateIsOpen) {
            state.isDialogOpen = Boolean(newStateIsOpen);
        },
        setConfirmationData(state, data) {
            state.confirmationData = data;
        },
        setPostFormTariffData(state, payload) {
            if (
                typeof payload === "object" &&
                !Array.isArray(payload) &&
                payload !== null
            ) {
                state.postFormTariffData = { ...payload };
            } else throw new Error("data must be an object");
        },
        setTariffsTab(state, newTab) {
            state.tariffsTab = newTab;
        },
        setNumberData(state, numberObj) {
            if (
                typeof numberObj === "object" &&
                !Array.isArray(numberObj) &&
                !!numberObj
            ) {
                if (!("system" in numberObj)) {
                    numberObj.system = "";
                }
                if (!("number" in numberObj)) {
                    numberObj.number = "";
                }
                if (!("serverId" in numberObj)) {
                    numberObj.serverId = "";
                }
                state.numberData = numberObj;
            } else {
                state.numberData = {};
            }
        },
        TOGGLE_HIDE_NUMBER(state, boolean) {
            let result = null // {}
            const visibility = { visibility: boolean }
            if (!!state.dialogParams?.info) {
                result = Object.assign(state.dialogParams.info, visibility)
            } else {
                result = state.dialogParams?.info
            }

            state.dialogParams.info = result
        },
        setTagsToDialogParams(state, tagList) {
            state.dialogParams.info.tags = tagList
        },
        // SET_NUMBER_TO_DIALOG_PARAMS(state, number) {
        //     state.dialogParams.number = number
        // },
        clearNumberData(state) {
            state.numberData = {};
        },

        openDialog(state, params) {
            state.dialogParams = params;
            if (typeof params === "string" || params instanceof String) {
                state.componentDialog = params;
            } else if (!!params && "name" in params) {
                state.componentDialog = params.name;
                if ("params" in params) {
                    state.dialogParams = params.params;
                }
            }
            if (state.componentDialog) {
                state.bodyClass.push("dialog-open");
                state.isDialogOpen = true;
            } else {
                console.error("Empty store.componentDialog");
            }
        },
        closeDialog(state, data = null) {
            state.bodyClass = state.bodyClass.filter((el) => {
                return el !== "dialog-open";
            });
            state.isDialogOpen = false;

            if (!!state.dialogParams?.onClose) {
                if (data) {
                    state.dialogParams.onClose(data);
                } else {
                    state.dialogParams.onClose();
                }
            }
            state.dialogParams = {};
            state.componentDialog = "";
            store.getters.bodyClassList;
        },
        isNav(state) {
            if (window.innerWidth < 640) {
                state.isNavOpen = !state.isNavOpen;

                if (!state.isNavOpen) {
                    state.bodyClass.push("nav-close");
                    store.getters.bodyClassList;
                } else {
                    state.bodyClass = state.bodyClass.filter((el) => {
                        return el !== "nav-close";
                    });

                    store.getters.bodyClassList;
                }
            } else {
                state.isNavOpen = true;
            }
        },
        setToastContent(state, { status, description }) {
            state.toastContent = { status, description }
        },
        clearToastContent(state) {
            state.toastContent = { status: '', description: '' };
        },
        setIsRelogin(state, booleanState) {
            state.isRelogin = booleanState
        }
    },
    actions: {
    },
    modules: {
        auth: authModule,
        numbers: numbersModule,
        activation: activationModule,
        notifications: notificationsModule,
        user: userModule,
        navBar: navBarModule,
        telephony: telephonyModule,
        tiktok: tiktokModule,
        invoice: invoiceModule,
    }
});

export default store;
